import { ReactNode } from 'react'

import { FormItemProps, Rule } from 'antd/lib/form'

import { CaptureBlockBase } from '../../types/blueprint'
import { FormItem } from '../CaptureBlock.style'

import { Text } from '@/components/shared-components/BUI/Text'
import { Flexbox } from '@/components/shared-components/Flexbox'

type Props<T, Y extends CaptureBlockBase> = {
  block: Y
  rules: Rule[]
  children: ReactNode
  initialValue: T
  label?: string
} & FormItemProps

export const CaptureBlockFormItem: React.FC<
  Props<unknown, CaptureBlockBase>
> = ({
  block,
  rules,
  children,
  initialValue,
  label = block.name,
  ...formItemProps
}) => {
  const { id, description } = block

  return (
    <FormItem
      label={
        label || description ? (
          <Flexbox flexDirection="column" gap="0.25em">
            {label && <Text variant="subheading02">{label}</Text>}
            {description && (
              <Text secondary="_500" variant="label02">
                {description}
              </Text>
            )}
          </Flexbox>
        ) : block.required ? (
          <Text variant="label02">Required</Text>
        ) : null
      }
      name={id}
      initialValue={initialValue}
      rules={rules}
      {...formItemProps}
    >
      {children}
    </FormItem>
  )
}
